import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { DataTable } from 'components/dataTable';
import { I18n, translate } from 'components/translate';
import { USER_ROLE } from 'configs/constants';
import { ROUTES } from 'configs/routes/constants';
import { sendEventCommentClassStatus } from 'modules/app/services/datahubEvents/moderationSupport/tryCommentClassStatus/utils/sendEventCommentClassStatus';
import { AuthService } from 'modules/auth';
import { CommunityService } from 'modules/community';
import CommentHeaderStatus from 'modules/community/commentList/CommentHeaderStatus';
import CommentListAnswerBox from 'modules/community/commentList/CommentListAnswerBox';
import CommentListService from 'modules/community/commentList/CommentListService';
import ContextModal from 'modules/community/commentList/ContextModal';
import { commentDataProptype } from 'modules/community/commentList/DataPropType';
import { COMMENT_STATUS_ENUM } from 'modules/community/constants';
import CommentDetailContent from 'modules/community/history/CommentDetailContent';
import PropTypes from 'prop-types';

import CommentBottomActions from './CommentBottomActions';

import './CommentListTableBody.scss';

const DEFAULT_ICON_SIZE = 14;
const EXCLAMATION_ICON_SIZE = 12;
const ANSWER_BOX_CLASS =
  'comment-list__comment-cell__container__comment__answer-box';

@translate()
export default class CommentListTableBody extends Component {
  static propTypes = {
    t: PropTypes.func,
    comments: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape(commentDataProptype)),
      PropTypes.object
    ]),
    columns: PropTypes.array,
    answerListText: PropTypes.object,
    answerListOpened: PropTypes.object,
    label: PropTypes.object,
    getUserComments: PropTypes.func,
    openAnswerBox: PropTypes.func,
    commentAnswerReply: PropTypes.func,
    closeAnswerBox: PropTypes.func,
    onAnswerText: PropTypes.func,
    fetchCommentsData: PropTypes.func,
    activedTab: PropTypes.number
  };

  state = {
    modalIsOpen: false,
    commentSelected: {},
    comments: [],
    showMoreComments: {}
  };

  constructor(props) {
    super(props);

    this.toogleContext = this.toogleContext.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showMore = this.showMore.bind(this);

    this.viewAsProducerIsAllowed = CommunityService.viewAsProducerIsAllowed;
  }

  redirectUserDetailIsAllowed = (user) =>
    user.type !== USER_ROLE.OWNER && !AuthService.isModerator();

  toogleContext(commentSelected = {}) {
    this.setState((prevState) => ({
      commentSelected,
      modalIsOpen: !prevState.modalIsOpen
    }));
  }

  closeModal() {
    this.toogleContext();
  }

  showMore(answerDataId) {
    const { showMoreComments } = this.state;

    showMoreComments[answerDataId] = true;

    this.setState({ showMoreComments });
  }

  sendStatusComment = async (item, status) => {
    try {
      const { fetchCommentsData } = this.props;

      await CommentListService.commentStatusUpdate(item, status);

      CommunityService.getCommunityNotifications();

      fetchCommentsData(CommunityService.commentListParams);

      sendEventCommentClassStatus({
        status,
        comment: item
      });
    } catch (error) {
      sendEventCommentClassStatus({
        isSuccess: false,
        status,
        failureDescription: error,
        comment: item
      });
    }
  };

  createAction = (
    actionCallback,
    icon,
    label,
    iconSize = DEFAULT_ICON_SIZE,
    status = ''
  ) => ({ key: label, actionCallback, icon, label, iconSize, status });

  get actions() {
    const { label, openAnswerBox } = this.props;

    return [
      this.createAction(openAnswerBox, 'reply', 'general.answer'),
      this.createAction(
        this.sendStatusComment,
        'check',
        label.approve,
        DEFAULT_ICON_SIZE,
        COMMENT_STATUS_ENUM.APPROVED
      ),
      this.createAction(
        this.sendStatusComment,
        'times',
        label.disapprove,
        DEFAULT_ICON_SIZE,
        COMMENT_STATUS_ENUM.DISAPPROVED
      ),
      this.createAction(
        this.sendStatusComment,
        'exclamation',
        label.spam,
        EXCLAMATION_ICON_SIZE,
        COMMENT_STATUS_ENUM.SPAM_CONFIRMED
      )
    ];
  }

  renderActionsButtons(item) {
    const {
      answerListOpened,
      answerListText,
      openAnswerBox,
      commentAnswerReply,
      closeAnswerBox,
      onAnswerText
    } = this.props;
    const isAnswerboxOpen = answerListOpened[item.id];
    const containerClass = classNames(`${ANSWER_BOX_CLASS}--is-mobile`, {
      [`${ANSWER_BOX_CLASS}--is-closed`]: !isAnswerboxOpen
    });

    return (
      <Fragment>
        <span className={containerClass}>
          {isAnswerboxOpen && (
            <CommentListAnswerBox
              item={item}
              answerListText={answerListText}
              answerListOpened={answerListOpened}
              openAnswerBox={openAnswerBox}
              commentAnswerReply={commentAnswerReply}
              closeAnswerBox={closeAnswerBox}
              onAnswerText={onAnswerText}
              isMobile
            />
          )}
        </span>

        <CommentBottomActions
          actions={this.actions}
          item={item}
          disabled={isAnswerboxOpen}
        />
      </Fragment>
    );
  }

  renderClass = ({ commentClass = {} }) => (
    <Fragment>
      <div className="comment-list__user-cell__container__class-name">
        {commentClass.name}
      </div>
      <hr className="comment-list__user-cell__container__divisor" />
    </Fragment>
  );

  renderSeeUserComments = (item) => {
    return (
      <div className="comment-list__user-cell__container__see-user-comments">
        <Link
          to={ROUTES.COMMUNITY.HISTORY.replace(':commentUserId', item.user.id)}
        >
          <I18n label="community.view_history" />
        </Link>
      </div>
    );
  };

  renderCommentName(item) {
    const label = this.props.t('community.in_page_name', {
      data: { pageName: item.page.name }
    });

    return (
      <div className="comment-list__user-cell__container__comment-name">
        {this.viewAsProducerIsAllowed ? (
          <a onClick={() => CommunityService.redirectClassAcademy(item)}>
            {label}
          </a>
        ) : (
          <div>{label}</div>
        )}
      </div>
    );
  }

  renderCommentFooter = (item) => (
    <div key={`footer_${item.id}`} className="comment-list__actions">
      <div className="comment-list__actions--first-column">
        {this.renderActionsButtons(item)}
      </div>
      <div className="comment-list__actions--view-history-column">
        {this.renderSeeUserComments(item)}
        <div className="comment-list__actions__see-context">
          <button
            className="hot-button hot-button--secondary hot-button--sm"
            onClick={() => this.toogleContext(item)}
          >
            <I18n label="community.see_context" />
          </button>
        </div>
      </div>
    </div>
  );

  renderCommentListCell = (item) => {
    const {
      answerListOpened,
      answerListText,
      openAnswerBox,
      commentAnswerReply,
      closeAnswerBox,
      onAnswerText
    } = this.props;
    const isAnswerboxOpen = answerListOpened[item.id];
    const AnswerBoxClass = classNames(`${ANSWER_BOX_CLASS}--is-desktop`, {
      [`${ANSWER_BOX_CLASS}--is-closed`]: !isAnswerboxOpen
    });

    return (
      <div className="comment-list__comment-cell__container">
        <CommentHeaderStatus item={item} showStatus />

        <CommentDetailContent item={item} />

        <span className={AnswerBoxClass}>
          {isAnswerboxOpen && (
            <CommentListAnswerBox
              item={item}
              answerListText={answerListText}
              answerListOpened={answerListOpened}
              openAnswerBox={openAnswerBox}
              commentAnswerReply={commentAnswerReply}
              closeAnswerBox={closeAnswerBox}
              onAnswerText={onAnswerText}
              isMobile={false}
            />
          )}
        </span>
      </div>
    );
  };

  renderUserData(item) {
    const redirectIsAllowed = this.redirectUserDetailIsAllowed(item.user);

    return (
      <div className="comment-list__user-cell__container">
        <div className="comment-list__user-cell__container__user-name">
          {redirectIsAllowed ? (
            <Link
              key={item.id}
              to={
                redirectIsAllowed &&
                ROUTES.USER.DETAIL.replace(':userId', item.user.userAreaId)
              }
            >
              {item.user.name}
            </Link>
          ) : (
            item.user.name
          )}
        </div>

        <div className="comment-list__user-cell__container__user-email">
          {item.user.email}
        </div>

        {this.renderCommentName(item)}

        {item.commentClass && item.commentClass.id && this.renderClass(item)}

        <div className="comment-list__actions--second-column">
          {this.renderActionsButtons(item)}
        </div>
      </div>
    );
  }

  render() {
    const { comments, columns } = this.props;
    const { modalIsOpen, commentSelected } = this.state;
    const columnsIndex = {
      commentsList: 0,
      userData: 1
    };

    return (
      <Fragment>
        <DataTable.Body className="comment-list__data-table__body">
          {comments.map((item) => (
            <Fragment key={item.id}>
              <DataTable.Row className="comment-list__data-table__body__row">
                <DataTable.SelectItem
                  className="comment-list__select-item"
                  item={item}
                />

                <DataTable.DataColumns>
                  <DataTable.Cell
                    columnName={columns[columnsIndex.commentsList].label}
                    className="comment-list__comment-cell"
                  >
                    {this.renderCommentListCell(item)}
                  </DataTable.Cell>

                  <DataTable.Cell
                    columnName={columns[columnsIndex.userData].label}
                    className="comment-list__user-cell"
                  >
                    {this.renderUserData(item)}
                  </DataTable.Cell>
                </DataTable.DataColumns>
              </DataTable.Row>

              <hr className="comment-list__data-table__body__divisor" />

              {this.renderCommentFooter(item)}
            </Fragment>
          ))}
        </DataTable.Body>
        {modalIsOpen && (
          <ContextModal
            commentSelected={commentSelected}
            onClose={this.closeModal}
          />
        )}
      </Fragment>
    );
  }
}
